import { render } from "./ChangePlanNew.vue?vue&type=template&id=0ba7e824&scoped=true"
import script from "./ChangePlanNew.vue?vue&type=script&lang=js"
export * from "./ChangePlanNew.vue?vue&type=script&lang=js"

import "./ChangePlanNew.vue?vue&type=style&index=0&id=0ba7e824&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba7e824"]])

export default __exports__